import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@apollo/client'

import type { Account } from '../getAttributesFromAccount'

export const BILLING_FIELDS = gql`
  fragment BillingFields on Billing {
    id
    ... on MPBilling {
      subscriptions {
        plan
        product
        trial {
          isActive
        }
      }
    }
    ... on OBBilling {
      hasNeverBeenPayingCustomer
      canStartTrial
      gateway {
        gatewayType
      }
      subscription {
        trial {
          isActive
        }
        plan {
          id
          name
        }
        interval
        startDate
        isCanceledAtPeriodEnd
      }
    }
  }
`

export const ORGANIZATION_FIELDS = gql`
  fragment OrganizationFields on Organization {
    id
    isOneBufferOrganization
    createdAt
    allowedActions
    billing {
      ...BillingFields
    }
  }
  ${BILLING_FIELDS}
`

export const ORG_DATA_QUERY: TypedDocumentNode<{
  account: Account | null
}> = gql`
  query OrgDataQuery {
    account {
      id
      isImpersonation
      email
      currentOrganization {
        ...OrganizationFields
      }
      organizations {
        ...OrganizationFields
      }
    }
  }
  ${ORGANIZATION_FIELDS}
`
